import AdminLeavesData from "./LeavesList/adminLeaveList";

const AdminLeavesDataWrapper = () => {
    return <AdminLeavesData />;
};

export default AdminLeavesDataWrapper;